import ContactsTable from "./ContactsTable";

export default ContactsTable;